import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { QueryClientProvider, QueryClient } from 'react-query';
import { MatomoProvider, createInstance } from '@datapunt/matomo-tracker-react';

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 1000 * 60, retry: false } },
});

// comment this out to test matomo locally if needed.
const isLocalhost = window.location.hostname === 'localhost';

const matomoInstance = createInstance({
  siteId: parseInt(import.meta.env.VITE_MATOMO_SITEID),
  urlBase: import.meta.env.VITE_MATOMO_BASEURL,
  disabled: isLocalhost,
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      {/* @ts-expect-error - MatomoProvider types don't properly support children in v0.5.1 */}
      <MatomoProvider value={matomoInstance}>
        <App />
      </MatomoProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
